// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dtcCardsContainer_LZlV3{
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0px;
  padding: 6px;
}

.dtcCard_U7u8O {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/attributes/renderers/vehicle/VehicleDTCAlertsHistory.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV","sourcesContent":[".dtcCardsContainer{\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin: 0px;\n  padding: 6px;\n}\n\n.dtcCard {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dtcCardsContainer": `dtcCardsContainer_LZlV3`,
	"dtcCard": `dtcCard_U7u8O`
};
export default ___CSS_LOADER_EXPORT___;
